import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20 max-w-6xl" }
const _hoisted_2 = { class: "flex items-center justify-between gap-4 mb-4" }

import { computed, provide, ref } from 'vue'
import { RouterView, useRoute } from 'vue-router'

import NeueButton from '@/components/neue/NeueButton.vue'
import NeueTabs from '@/components/neue/NeueTabs.vue'
import { useMarketing } from '@/composables/useMarketing'
import { useToast } from '@/composables/useToast'

import MarketingSettingsDrawer from './MarketingSettingsDrawer.vue'


export default {
  __name: 'MarketingShell',
  setup(__props, { expose: __expose }) {

const route = useRoute()
const tabs = computed(() => [
  { id: 'plan', name: 'Plan', to: '/marketing', active: route.path === '/marketing' },
  {
    id: 'performance',
    name: 'Performance',
    to: '/marketing/performance',
    active: route.path.startsWith('/marketing/performance')
  },
  { id: 'history', name: 'History', to: '/marketing/history', active: route.path.startsWith('/marketing/history') }
])

// One composable instance for every tab, so the drawer and the pages share the agent.
const marketing = useMarketing()
provide('marketing', marketing)
const { showToast } = useToast()

const settingsOpen = ref(false)
const saving = ref(false)

// Performance never loads the agent, so fetch it before the drawer syncs its form on open.
const openSettings = async () => {
  if (!marketing.agent.value) await marketing.loadAgent()
  settingsOpen.value = true
}

const onSave = async settings => {
  saving.value = true
  try {
    await marketing.updateAgent(settings)
    showToast('Settings saved.', { type: 'success' })
    settingsOpen.value = false
  } catch (e) {
    showToast(marketing.errorOf(e), { type: 'error' })
  } finally {
    saving.value = false
  }
}

provide('marketingSettings', {
  isOpen: settingsOpen,
  open: openSettings,
  close: () => (settingsOpen.value = false)
})
__expose({ settingsOpen })

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-2xl font-bold text-gray-900" }, "Marketing", -1)),
      _createVNode(NeueButton, {
        type: "secondary",
        "data-settings": "",
        onClick: openSettings
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Settings", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(NeueTabs, {
      tabs: tabs.value,
      "aria-label": "Marketing sections",
      class: "mb-6"
    }, null, 8, ["tabs"]),
    _createVNode(_unref(RouterView)),
    _createVNode(MarketingSettingsDrawer, {
      agent: _unref(marketing).agent.value,
      busy: saving.value,
      onSave: onSave
    }, null, 8, ["agent", "busy"])
  ]))
}
}

}